<template>
  <div class="video_explain flex-col">
    <div v-for="item in explainData" :key="item.id" class="videoItem flex-row" @click="play(item)">
      <div class="playImg">
        <img
          src="https://img01.yzcdn.cn/upload_files/2021/02/19/FgZwGWf-yr8BucmywqVsMRBwDXtd.png"
          alt="无图片"
          class="imgBottom"
        />
        <img
          class="iconBottom position_center"
          src="https://img.yzcdn.cn/upload_files/2020/12/07/FiumP5V_LqBVfzgZIX3AU-0rWr2H.png"
          alt="play"
        />
        <div v-if="!hasRight" class="vip_tag">
          <img
            src="https://img.yzcdn.cn/upload_files/2020/12/07/FmesChEYjxtApMXRBBQfpb0MVOnl.png"
            alt="1"
          />
        </div>
      </div>
      <div class="msg flex-col flex-jc-bt">
        <div class="top">
          <h3>讲解老师·{{ item.anchorName || '子衿老师' }}</h3>
          <div class="time flex-row flex-al-center">
            <span
              v-if="sortValue[item.index]"
              class="tag"
              :class="[sortValue[item.index].className]"
            >
              {{ sortValue[item.index].text }}
            </span>
            <span class="lineTime ">{{ format('yyyy-MM-dd', item.create_time) }}</span>
          </div>
        </div>
        <div class="bottom flex-row flex-jc-bt flex-al-center">
          <div class="iconItem flex-row flex-al-center">
            <img
              src="https://img01.yzcdn.cn/upload_files/2021/02/19/FoUlN2wmEAU0DOcxKq-yzK85HZlr.png"
            />
            <span>{{ item.play_volume || 0 }} 次</span>
          </div>
          <div class="iconItem flex-row flex-al-center">
            <img
              src="https://img01.yzcdn.cn/upload_files/2021/02/19/FoiR5nCSrg4IVISuXCx-L9D1Qnwu.png"
            />
            <span>{{ item.yct || 0 }} 次</span>
          </div>
        </div>
      </div>
    </div>
    <VanPopup
      v-model="playShow"
      position="top"
      closeable
      :close-on-click-overlay="false"
      lazy-render
    >
      <div v-if="playShow" class="video_open">
        <div class="video_title">
          <span>视频讲解</span>
        </div>
        <div class="videoPlayer">
          <VideoPlayer
            :source="path"
            :iframe="explain.mediaType !== 'video_vod'"
            :ali-video-id="explain.mediaType === 'video_vod' ? explain.mediaSource.trim() : ''"
          />
        </div>
        <LivingRoom :check-sv="checkSv" entry-type="type2" />
        <LikeModule :explain="explain" :check-sv="checkSv" />
      </div>
    </VanPopup>
  </div>
</template>
<script>
import { Popup } from 'vant'
import VideoPlayer from '@/components/videoPlayer'
import LikeModule from './likeModule'
import LivingRoom from './livingRoom'

import { saveViewExplainRecord } from '@/api/explain'
import { mapState } from 'vuex'
import { format } from '@/static/js/zjs'
export default {
  components: {
    VanPopup: Popup,
    VideoPlayer,
    LikeModule,
    LivingRoom
  },
  props: {
    explainData: {
      type: Array,
      default: () => []
    },
    hasRight: {
      type: Boolean,
      default: false
    },
    checkSv: {
      type: Function,
      default: () => () => {}
    }
  },
  data() {
    return {
      playShow: false,
      path: '',
      explain: {},
      sortValue: {
        '1': {
          text: '教师推荐',
          className: 'living_grape'
        },
        '2': {
          text: '最新',
          className: 'living_green'
        },
        '3': {
          text: '最热',
          className: 'living_org'
        },
        '4': {
          text: '好评',
          className: 'living_blue'
        }
      }
    }
  },
  computed: {
    ...mapState('answerExplain', ['allExplains'])
  },
  methods: {
    format,
    play(item) {
      u.rs.todotip('lookExplain', 1)
      this.checkSv(() => {
        saveViewExplainRecord(item.id)
        this.$store.commit('answerExplain/setExplainNum', {
          explainId: item.id,
          type: 'play_volume'
        })
        this.$store.commit('answerExplain/setHasViewVideoExplain', true)
        this.explain = item
        this.path = this.getVideoPath(item)
        this.playShow = true
      })
    },
    // 解析播放地址
    getVideoPath(explain) {
      // video_vod("阿里云点播")，video_tecent("腾讯视频")，video_youku("优酷视频")，audio("音频")，img("图片")，word("文字")
      const videoId = explain.mediaSource
      let url = ''
      switch (explain.mediaType) {
        case 'video_vod':
          url = `/cms/aliyun/video/play?videoId=${videoId}`
          break
        case 'video_tecent':
          url = `https://v.qq.com/txp/iframe/player.html?vid=${videoId}&height=185&auto=0`
          break
        case 'video_youku':
          url = `https://player.youku.com/embed/${videoId}`
          break
        default:
          break
      }
      return url
    }
  }
}
</script>
<style lang="scss">
.video_explain {
  .videoItem {
    padding: 12px;
    background: #ffffff;
    border: 1px solid #f3f6f9;
    box-sizing: border-box;
    box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0px;
    }
    .playImg {
      position: relative;
      width: 125px;
      border-radius: 6px;
      overflow: hidden;
      .imgBottom {
        width: 100%;
        height: 100%;
      }
      .iconBottom {
        width: 24px;
      }
      .vip_tag {
        position: absolute;
        z-index: 10;
        left: 5px;
        top: 5px;
        img {
          width: 40px;
        }
      }
    }
    .msg {
      margin-left: 10px;
      flex-grow: 1;
      .top {
        h3 {
          margin: 0%;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
        }
        .time {
          margin-top: 6px;
          .tag {
            display: inline-block;
            padding: 2px 4px;
            border-radius: 2px;
            font-size: 9px !important;
          }
          .living_grape {
            background: rgba(155, 107, 255, 0.15);
            color: #a751fd;
          }
          .living_green {
            background: rgba(99, 205, 151, 0.15);
            color: #20b86a;
          }
          .living_org {
            background: rgba(241, 149, 64, 0.15);
            color: #ff7a00;
          }
          .living_blue {
            background: rgba(70, 165, 248, 0.15);
            color: #3498ef;
          }
          .lineTime {
            margin-left: 6px;
            font-size: 12px;
            color: #666464;
          }
        }
      }
      .bottom {
        .iconItem {
          font-size: 12px;
          color: #999999;
          img {
            width: 8px;
            margin-right: 6px;
          }
          &:last-child {
            img {
              width: 12px;
            }
          }
        }
      }
    }
  }
}
.video_explain {
  .van-popup__close-icon--top-right {
    top: 10px;
  }
}
.video_open {
  .video_title {
    padding: 0 80px 0 20px;
    height: 42px;
    line-height: 42px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    background-color: #ffffff;
    border-radius: 2px 2px 0 0;
  }
  .videoPlayer {
    height: 239px;
  }
  iframe {
    width: 100%;
  }
}
.vip_right_icon {
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 43px;
    height: 43px;
    right: 0;
    top: 0;
    background-image: url(/cms/static/explain/images/vip_zx_icon.png);
    background-size: 43px 43px;
    background-position: center center;
  }
}
</style>
